import { render, staticRenderFns } from "./SVGAdminCustomers.vue?vue&type=template&id=789051bd&scoped=true&"
import script from "./SVGAdminCustomers.vue?vue&type=script&lang=js&"
export * from "./SVGAdminCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789051bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789051bd')) {
      api.createRecord('789051bd', component.options)
    } else {
      api.reload('789051bd', component.options)
    }
    module.hot.accept("./SVGAdminCustomers.vue?vue&type=template&id=789051bd&scoped=true&", function () {
      api.rerender('789051bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminCustomers.vue"
export default component.exports